export const options = {
  expanded: ['root'],
  block: { height: '90%', width: '100%', flexGrow: 1 },
};
